module.exports = __webpack_public_path__ + "media/images/redesign-images/get-inspired/gi-always-inspired-medium-df66bbe653081e4a392e7c0d86b0ac82.jpg";